import { useTranslation } from 'react-i18next';

import { AdviserAbsence } from './components/AdviserAbsence';
import { BankReports } from './components/bankReports/BankReports';
import { LeadInfo } from './components/LeadInfo';
import { NewDocuments } from './components/newDocuments/NewDocuments';
import { Representation } from './components/representation/Representation';
import { Resubmissions } from './components/resubmissions/Resubmissions';
import { useUserData } from '~/components/Header/menu/hooks/useUserData';
import Spinner from '~/components/icons/Spinner';
import useUserInfo from '~/hooks/useUserInfo';

export const DashboardView = () => {
    const { t } = useTranslation();
    const userInfo = useUserInfo();
    const { data: user } = useUserData(userInfo?.id);
    return (
        <section className="pt-4 pb-2.5 xl:px-8 px-4">
            <h4 className="mb-2 text-lg font-medium sm:text-xl lg:text-2xl text-midnight">
                {t('DASHBOARD.TITLE')} {user?.firstName} {user?.lastName}
            </h4>

            {user && userInfo ? (
                <section className="flex flex-col gap-4">
                    <span className="text-lg font-medium text-midnight">{t('DASHBOARD.SECTION_NEWS')}</span>
                    <div className="flex flex-wrap gap-4">
                        <div className="border border-grey-stroke flex-1 min-h-[250px] min-w-[500px] bg-white rounded-md px-4 py-4">
                            <Resubmissions />
                        </div>
                        <div className="border border-grey-stroke flex-1 min-h-[250px] min-w-[500px] bg-white rounded-md px-4 py-4">
                            <NewDocuments />
                        </div>
                        <div className="border border-grey-stroke flex-1 min-h-[250px] min-w-[500px] bg-white rounded-md px-4 py-4">
                            <BankReports />
                        </div>
                    </div>
                    <span className="text-lg font-medium text-midnight">{t('DASHBOARD.SECTION_ORGANIZATION')}</span>
                    <div className="flex flex-wrap gap-4">
                        <div className="border border-grey-stroke flex-1 min-h-[250px] min-w-[450px] bg-white rounded-md p-4">
                            <LeadInfo user={user} />
                        </div>
                        <div className="border border-grey-stroke flex-1 min-h-[250px] min-w-[450px] bg-white rounded-md p-4">
                            <AdviserAbsence userId={userInfo.id} />
                        </div>
                        <div className="border border-grey-stroke flex-1 min-h-[250px] min-w-[450px] bg-white rounded-md p-4">
                            <Representation userId={userInfo.id} />
                        </div>
                    </div>
                </section>
            ) : (
                <div className="w-full inset-0 flex items-center justify-center z-50">
                    <Spinner />
                </div>
            )}
        </section>
    );
};
